/** 트래커가 sentinel 을 찾고 값을 읽는 속성 */
export const SECTION_VIEW_ATTR = 'data-section-view';
export const SECTION_NAME_ATTR = 'data-section-name';

/**
 * 메인페이지 섹션. `section` 은 순서(퍼널 정렬 축), `name` 은 리포트를 읽는 사람용 축.
 * 둘 다 이벤트 파라미터로 그대로 나가므로 바꾸면 Datadog·GA 집계 연속성이 깨진다.
 *
 * 개편 전후 비교는 `section` 숫자가 아니라 `name` + 배포일 기간 필터로 한다 —
 * 페이지 구조가 바뀌면 순서 숫자의 의미도 바뀌기 때문이다(개편 전 6개 → 2.0 은 10개).
 * `hero`·`partners`·`cta`·`footer` 는 개편 전과 같은 성격의 섹션이라 이름을 유지해
 * 그대로 비교할 수 있다. 개편 전에만 있던 `news`(2)·`product`(3) 는 대응 섹션이 없다.
 */
export const MAIN_SECTION = {
  HERO: { section: 1, name: 'hero' },
  MARQUEE: { section: 2, name: 'marquee' },
  STORY: { section: 3, name: 'story' },
  TRANSITION: { section: 4, name: 'transition' },
  HIGHLIGHT: { section: 5, name: 'highlight' },
  REANALYSIS: { section: 6, name: 'reanalysis' },
  ORDER: { section: 7, name: 'order' },
  PARTNERS: { section: 8, name: 'partners' },
  CTA: { section: 9, name: 'cta' },
  FOOTER: { section: 10, name: 'footer' },
} as const;

type Props = {
  section: (typeof MAIN_SECTION)[keyof typeof MAIN_SECTION];
};

/**
 * 섹션 도달 기준선. 높이 0 이라 레이아웃에 영향이 없고, 뷰포트에 들어오는 순간
 * SectionViewTracker 가 section_view 를 보낸다.
 *
 * ⚠️ flex/grid 컨테이너 안에 두지 말 것 — gap 이 있으면 높이 0 이라도 간격이 생긴다.
 * 섹션 루트가 flex 면 섹션 바깥(바로 앞)에 둔다.
 */
export function SectionViewSentinel({ section }: Props) {
  return (
    <div
      data-section-view={section.section}
      data-section-name={section.name}
      aria-hidden="true"
      className="h-0"
    />
  );
}
